// Tracker Mist PDP — vanilla JS behavior (gallery, pack selector, upsell, FAQ,
// sticky bar, add-to-cart toast). Reads pack and upsell data from data-tm-pdp
// JSON config rendered server-side by the section.

(function () {
  const root = document.querySelector('[data-tm-pdp]');
  if (!root) return;

  let CONFIG;
  try {
    CONFIG = JSON.parse(root.getAttribute('data-tm-pdp'));
  } catch (e) {
    console.error('Tracker Mist PDP: malformed config', e);
    return;
  }

  const PACKS = CONFIG.packs || [];
  const UPSELLS = CONFIG.upsells || [];
  const GALLERY = CONFIG.gallery || [];
  const TRACKER_VARIANT_ID = CONFIG.trackerVariantId;
  const KEYRING_VARIANT_ID = CONFIG.keyringVariantId;
  const PAID_UPSELL_PRICE = Number(CONFIG.paidUpsellPrice) || 9.99;

  const state = {
    packId: PACKS[0]?.id,
    upsellId: UPSELLS.find((u) => u.free)?.id || UPSELLS[0]?.id,
    galIdx: 0,
  };

  // ---- Pack selector ----
  const packCards = root.querySelectorAll('.pack-card');
  const buyTitleAccent = root.querySelector('.buy-title .accent');
  const buyPriceNow = root.querySelector('.price-now');
  const buyPriceWas = root.querySelector('.price-was');
  const buyPriceSave = root.querySelector('.price-save');
  const buyPriceMeta = root.querySelector('.price-meta strong');
  const buyCta = root.querySelector('.order-cta');
  const buyCtaPrice = root.querySelector('.order-cta-price');
  const stickyPriceNow = document.querySelector('.sticky-buy .p-now');
  const stickyPriceWas = document.querySelector('.sticky-buy .p-was');
  const stickyTitle = document.querySelector('.sticky-buy h5');

  function getUpsellAddon() {
    return state.upsellId === 'paid' ? PAID_UPSELL_PRICE : 0;
  }

  function applyPricing() {
    const pack = PACKS.find((p) => p.id === state.packId) || PACKS[0];
    if (!pack) return;
    const total = (Number(pack.price) + getUpsellAddon()).toFixed(2);
    if (buyPriceNow) buyPriceNow.textContent = '$' + total;
    if (buyCtaPrice) buyCtaPrice.textContent = '$' + total;
    if (stickyPriceNow) stickyPriceNow.textContent = '$' + total;
  }

  function applyPack() {
    const pack = PACKS.find((p) => p.id === state.packId) || PACKS[0];
    if (!pack) return;
    packCards.forEach((c) => {
      c.classList.toggle('active', String(c.dataset.packId) === String(pack.id));
    });
    if (buyTitleAccent) buyTitleAccent.textContent = pack.label;
    const compare = Number(pack.compare).toFixed(2);
    const save = (pack.compare - pack.price).toFixed(2);
    const pct = Math.round(((pack.compare - pack.price) / pack.compare) * 100);
    if (buyPriceWas) buyPriceWas.textContent = '$' + compare;
    if (buyPriceSave) buyPriceSave.textContent = `Save ${pct}% · $${save}`;
    if (buyPriceMeta) buyPriceMeta.textContent = `4× $${(pack.price / 4).toFixed(2)}`;
    if (stickyPriceWas) stickyPriceWas.textContent = '$' + compare;
    if (stickyTitle) stickyTitle.textContent = `Tracker Mist · ${pack.label}`;
    applyPricing();
    if (pack.heroImg) {
      state.galIdx = 0;
      const firstSlide = root.querySelector('.gal-slide-img:first-child img');
      const firstThumb = root.querySelector('.gal-thumb-img:first-child img');
      if (firstSlide) firstSlide.src = pack.heroImg;
      if (firstThumb) firstThumb.src = pack.heroImg;
      applyGallery();
    }
  }

  packCards.forEach((card) => {
    card.addEventListener('click', () => {
      const id = card.dataset.packId;
      state.packId = isNaN(Number(id)) ? id : Number(id);
      applyPack();
    });
  });

  // ---- Upsell ----
  const upsellBtns = root.querySelectorAll('.upsell');
  upsellBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      state.upsellId = btn.dataset.upsellId;
      upsellBtns.forEach((b) =>
        b.classList.toggle('active', b.dataset.upsellId === state.upsellId)
      );
      applyPricing();
    });
  });

  // ---- Gallery ----
  const slides = root.querySelectorAll('.gal-slide');
  const thumbs = root.querySelectorAll('.gal-thumb');
  const dots = root.querySelectorAll('.gal-dot');
  const counter = root.querySelector('.gal-counter');
  const galStage = root.querySelector('.gal-stage');
  const len = slides.length;

  function applyGallery() {
    slides.forEach((s, i) => s.classList.toggle('active', i === state.galIdx));
    thumbs.forEach((t, i) => t.classList.toggle('active', i === state.galIdx));
    dots.forEach((d, i) => d.classList.toggle('active', i === state.galIdx));
    if (counter) counter.textContent = `${state.galIdx + 1} / ${len}`;
    if (galStage) {
      const cur = slides[state.galIdx];
      galStage.classList.toggle('is-video', cur && cur.classList.contains('gal-slide-video'));
    }
    // pause videos that aren't visible
    root.querySelectorAll('.gal-video-el').forEach((v, i) => {
      if (i !== state.galIdx) {
        v.pause();
        v.currentTime = 0;
      }
    });
  }

  function go(n) {
    state.galIdx = ((n % len) + len) % len;
    applyGallery();
  }

  root.querySelector('.gal-arrow.left')?.addEventListener('click', () => go(state.galIdx - 1));
  root.querySelector('.gal-arrow.right')?.addEventListener('click', () => go(state.galIdx + 1));
  thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
  dots.forEach((d, i) => d.addEventListener('click', () => go(i)));

  // Auto-advance
  let autoTimer = setInterval(() => go(state.galIdx + 1), 5000);
  root.querySelector('.gal-stage')?.addEventListener('mouseenter', () => clearInterval(autoTimer));
  root.querySelector('.gal-stage')?.addEventListener('mouseleave', () => {
    autoTimer = setInterval(() => go(state.galIdx + 1), 5000);
  });

  // Video click-to-play on current slide
  root.querySelectorAll('.gal-video').forEach((wrap, i) => {
    const v = wrap.querySelector('.gal-video-el');
    const playBtn = wrap.querySelector('.gal-video-play');
    const toggle = (e) => {
      if (e) e.stopPropagation();
      if (!v) return;
      if (v.paused) {
        v.play();
        if (playBtn) playBtn.style.display = 'none';
      } else {
        v.pause();
        if (playBtn) playBtn.style.display = '';
      }
    };
    wrap.addEventListener('click', toggle);
    if (playBtn) playBtn.addEventListener('click', toggle);
  });

  // ---- FAQ accordion ----
  const faqItems = root.querySelectorAll('.faq-item');
  faqItems.forEach((item, i) => {
    const q = item.querySelector('.faq-q');
    if (!q) return;
    q.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      faqItems.forEach((it) => it.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
    if (i === 0) item.classList.add('open');
  });

  // ---- Sticky buy bar ----
  const stickyBar = document.querySelector('.sticky-buy');
  if (stickyBar) {
    const onScroll = () => {
      stickyBar.classList.toggle('show', window.scrollY > 700);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---- Order Now → empty cart, add pack items, redirect to checkout ----
  async function checkout() {
    const pack = PACKS.find((p) => p.id === state.packId) || PACKS[0];
    if (!pack) return;
    if (!TRACKER_VARIANT_ID || !KEYRING_VARIANT_ID) {
      alert('This product is not configured for checkout yet. Set tracker and key-ring variant IDs in the theme editor.');
      return;
    }
    const items = [
      { id: Number(TRACKER_VARIANT_ID), quantity: pack.qty },
      { id: Number(KEYRING_VARIANT_ID), quantity: pack.qty },
    ];
    try {
      await fetch('/cart/clear.js', { method: 'POST' });
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        const detail = body.description || body.message || `HTTP ${res.status}`;
        console.error('cart/add.js response:', body);
        throw new Error(detail);
      }
      const code = state.upsellId === 'paid'
        ? (pack.paidDiscountCode || pack.discountCode || '')
        : (pack.discountCode || '');
      const url = code ? `/checkout?discount=${encodeURIComponent(code)}` : '/checkout';
      window.location.href = url;
    } catch (err) {
      console.error(err);
      alert('Could not start checkout: ' + err.message);
    }
  }

  const form = root.querySelector('form[data-tm-cart-form]');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      checkout();
    });
  }
  document.querySelector('.sticky-buy .order-cta-sticky')?.addEventListener('click', checkout);

  // Initial state
  applyPack();
  applyGallery();
})();